
export default function TextField(theme) {
    return {
        MuiTextField: {
            styleOverrides: {
                root: {
                    backgroundColor: "white",
                    borderRadius: 8,
                }
            }
        }
    }
}